<template>
    <jet-authentication-card>
        <Head title="Forgot Password" />

        <template #logo>
            <jet-authentication-card-header>
                <!--<a href="/" title="Throbo" class="dark:hidden"><img src="/images/app_logo_login.png" alt="Throbo Logo" /></a>-->
                <!--<a href="/" title="Throbo" class="hidden dark:block"><img src="/images/app_logo_login_dark.png" alt="Throbo Logo" /></a>-->
                <template #title> Reset Your Password </template>
                <template #link>
                    <Link :href="route('login')" class="hover:text-indigo-700 text-indigo-900 dark:text-slate-300 dark:hover:text-slate-100 font-medium dark:underline"> sign into your account </Link>
                </template>
            </jet-authentication-card-header>
        </template>

        <div class="flex flex-col space-y-4 sm:-mx-5 sm:-my-4 pt-3">
            <div v-if="status" class="text-center text-green-600 text-lg font-medium">
                {{ status }}
            </div>

            <div class="text-gray-600 dark:text-slate-50 leading-6">
                <span class="font-semibold">Forgot your password?</span>
                No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
            </div>

            <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-500" />

            <jet-validation-errors />

            <form @submit.prevent="submit">
                <div class="text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100">
                    <!--<jet-label for="email" value="Email Address" />-->
                    <label class="block text-sm font-medium" for="password">Email Password</label>
                    <jet-input id="email" type="email" class="block mt-1 w-full" v-model="form.email" required autofocus />
                </div>

                <div class="flex flex-col items-center justify-end mt-4">
                    <jet-button class="justify-center mb-2 w-full text-base" :processing="form.processing"> Email Password Reset Link </jet-button>
                </div>
            </form>
        </div>
    </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard"
import JetAuthenticationCardHeader from "@/Jetstream/AuthenticationCardHeader"
import JetButton from "@/Jetstream/Button"
import JetInput from "@/Jetstream/Input"
import JetLabel from "@/Jetstream/Label"
import JetValidationErrors from "@/Jetstream/ValidationErrors"

export default {
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardHeader,
        JetButton,
        JetInput,
        JetLabel,
        JetValidationErrors,
    },

    props: {
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: "",
            }),
        }
    },

    methods: {
        submit() {
            this.form.post(this.route("password.email"))
        },
    },
}
</script>
